// Auto-generated icon module
const svg = `<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
	<path d="M20,12.5h-7.5V20h-1v-7.5H4v-1h7.5V4h1v7.5H20V12.5z" />
</svg>
`;

export { svg as default };
//# sourceMappingURL=it-plus-D7lUBn02.js.map
